module.exports = {
  SET_PRODUCT: 'SET_PRODUCT',
  FETCHING_PRODUCT: 'FETCHING_PRODUCT',
  FETCHED_PRODUCT: 'FETCHED_PRODUCT',
  FETCH_PRODUCT_ERROR: 'FETCH_PRODUCT_ERROR',
  SET_PRODUCT_SALES: 'SET_PRODUCT_SALES',
  FETCHING_PRODUCT_SALES: 'FETCHING_PRODUCT_SALES',
  FETCHED_PRODUCT_SALES: 'FETCHED_PRODUCT_SALES',
  FETCH_PRODUCT_SALES_ERROR: 'FETCH_PRODUCT_SALES_ERROR',
  SET_PRODUCT_TAGS: 'SET_PRODUCT_TAGS',
  FETCHING_PRODUCT_TAGS: 'FETCHING_PRODUCT_TAGS',
  FETCHED_PRODUCT_TAGS: 'FETCHED_PRODUCT_TAGS',
  FETCH_PRODUCT_TAGS_ERROR: 'FETCH_PRODUCT_TAGS_ERROR',
};
